import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import HomePage from "./pages/HomePage";
import RulesPage from "./pages/RulesPage";
import ContactsPage from "./pages/ContactsPage";
import HowToFindPage from "./pages/HowToFindPage";
import BookingSuccessPage from "./pages/BookingSuccessPage";
import PrivacyPage from "./pages/PrivacyPage";
import AgreementPage from "./pages/AgreementPage";
import { CookieNotification } from "./components/CookieNotification";

function App() {
  return (
    <BrowserRouter>
      <CookieNotification />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/rules" element={<RulesPage />} />
        <Route path="/contacts" element={<ContactsPage />} />
        <Route path="/how-to-find" element={<HowToFindPage />} />
        <Route path="/booking-success" element={<BookingSuccessPage />} />
        <Route path="/policy" element={<PrivacyPage />} />
        <Route path="/agreement" element={<AgreementPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
